export const ariyaPrefix = "/worldpremiere";
export const apiPrefix = ariyaPrefix + "/data";
export const apiPrefix_Dp = ariyaPrefix + "/dp_data";
